import * as React from 'react';
import { StyledGridCell } from './StyledGridCell';

export const GridThreeQuarters = ({children, className = ""}) => <StyledGridCell lg={9} xs={12} item={true} className={className}>{children}</StyledGridCell>;
